<script setup lang="ts">
import { usePejer } from '@/Pejer'
import DataStateButton from 'pejer/src/components/DataState/DataStateButton.vue'
import { Button } from 'pejer/src/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from 'pejer/src/components/ui/dialog'
import DialogFooter from 'pejer/src/components/ui/dialog/DialogFooter.vue'
import usePejerMutation from 'pejer/src/usePejerMutation'
import { ref } from 'vue'
import { ClubAccountItem, formatKroner } from './types'

const props = defineProps<{
  item: ClubAccountItem
}>()

const isOpen = ref(false)
const pejer = usePejer()

// The refund endpoint cancels an invoice that has no payments.
const { mutate, dataState } = usePejerMutation(
  pejer.urls.payments.refund,
  {
    queryKeys: [['payments'], ['invoices']],
    onSuccess: () => {
      isOpen.value = false
    },
  },
  { toastOnSuccess: { title: 'Fakturaen er kansellert' } }
)
</script>
<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogContent class="max-w-[calc(100vw-20px)] max-h-[calc(100vh-50px)] flex flex-col">
      <DialogTitle class="flex flex-col gap-1">
        <span class="text-muted-foreground text-sm">{{ item.customerName }}</span>
        <span class="text-lg font-semibold">Kanseller faktura</span>
      </DialogTitle>
      <DialogDescription class="text-sm text-slate-600">
        Fakturaen på {{ formatKroner(item.grossKroner) }} kanselleres. Er den sendt som e-faktura
        eller EHF, får mottakeren en kreditnota automatisk. Handlingen kan ikke angres.
      </DialogDescription>
      <DialogFooter>
        <DialogClose as-child>
          <Button variant="ghost">Avbryt</Button>
        </DialogClose>
        <DataStateButton
          :data-state="dataState"
          @click.prevent.stop="mutate({ pathArgs: { id: item.paymentReferenceID } })"
        >
          Kanseller faktura
        </DataStateButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
